<!--eslint-disable-->
<template>
  <div class="help_main">
    <iframe style="width: 100%;height: 700px;" src="/Help-demo.pdf"></iframe>
  </div>
</template>

<script>
/* eslint-disable */
export default {

}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
